import React, { createContext, useContext, useMemo } from 'react'

import { useAuthInfo } from '@sweetauth/core'

import { createAwardExistenceLoader } from '@/services/award-existence-loader'
import DataLoader from '@/vendor/dataloader'

type LoaderContextType = DataLoader<string, boolean> | null | undefined

const LoaderContext = createContext<LoaderContextType>(undefined)

type AwardExistenceLoaderProviderProps = {
  children: React.ReactNode
}

export const AwardExistenceLoaderProvider: React.FC<
  AwardExistenceLoaderProviderProps
> = ({ children }) => {
  const { accessToken } = useAuthInfo()
  const loader = useMemo(() => {
    return accessToken ? createAwardExistenceLoader(accessToken) : null
  }, [accessToken])

  return (
    <LoaderContext.Provider value={loader}>{children}</LoaderContext.Provider>
  )
}

export const useAwardExistenceLoader = () => {
  const context = useContext(LoaderContext)

  if (context === undefined) {
    throw new Error(
      'useAwardExistenceLoader must be used within an AwardExistenceLoaderProvider',
    )
  }

  return context
}
